import { afterNextRender, DOCUMENT, inject, Injectable } from '@angular/core';
import { ContextService } from '@services/context';

@Injectable({
  providedIn: 'root',
})
export class MagnetisService {
  readonly #window = inject<Document>(DOCUMENT).defaultView;

  constructor() {
    if (!inject(ContextService).isBrowser()) return;
    afterNextRender(() => this.#observe());
  }

  #observe(): void {
    let timer: ReturnType<typeof setTimeout>;
    const swap = () => this.#window?.mgtmod?.swapNumbers();

    const observer = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(swap, 300);
    });

    observer.observe(this.#window!.document.body, { childList: true, subtree: true });
  }
}
